<template>
  <div>
    <label>
      <span v-if="label">{{ label }}</span>
    </label>
    <woot-thumbnail
      v-if="src"
      size="80px"
      :src="src"
      :username="usernameAvatar"
    />
    <div v-if="src && deleteAvatar" class="avatar-delete-btn">
      <woot-button
        color-scheme="alert"
        variant="hollow"
        size="tiny"
        type="button"
        @click="onAvatarDelete"
      >
        {{ $t('INBOX_MGMT.DELETE.AVATAR_DELETE_BUTTON_TEXT') }}
      </woot-button>
    </div>
    <label>
      <input
        id="file"
        ref="file"
        type="file"
        accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
        @change="handleImageUpload"
      />
      <slot />
    </label>
    <div v-if="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    usernameAvatar: {
      type: String,
      default: '',
    },
    deleteAvatar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorMessage: '',
    };
  },
  watch: {},
  methods: {
    validateFile(file) {
      // Reset error message
      this.errorMessage = '';
      
      // Check file type
      const acceptableTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      if (!acceptableTypes.includes(file.type)) {
        this.errorMessage = 'File type not supported. Please upload JPEG, PNG, GIF or WebP.';
        return false;
      }
      
      // Check file extension to prevent JFIF files
      const fileName = file.name.toLowerCase();
      if (fileName.endsWith('.jfif')) {
        this.errorMessage = 'JFIF format not supported. Please convert to JPEG or PNG.';
        return false;
      }
      
      return true;
    },
    handleImageUpload(event) {
      const [file] = event.target.files;
      
      if (!file) return;
      
      if (this.validateFile(file)) {
        this.$emit('change', {
          file,
          url: URL.createObjectURL(file),
        });
      } else {
        // Clear the file input if validation fails
        this.$refs.file.value = null;
      }
    },
    onAvatarDelete() {
      this.$refs.file.value = null;
      this.$emit('onAvatarDelete');
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-delete-btn {
  margin-top: var(--space-smaller);
  margin-bottom: var(--space-smaller);
}
.error-message {
  color: var(--r-500);
  font-size: var(--font-size-small);
  margin-top: var(--space-smaller);
}
</style>